/* @refresh reload */
import { render } from "solid-js/web";
import { App } from "./app";
import { startPerf } from "./lib/perf";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root mancante — fail-closed, niente magia");

// Shell offline (D1/D2 offline-first, build plan M0 "Tutto offline"): the service worker is
// GENERATED at build time (scripts/build-sw.mjs). Not registered in dev (no cache interfering
// with HMR). Registration failure is non-fatal (app works online): warn in console, never a
// naked exception to the user.
//
// UPDATE FLOW (regression 2026-09-24: iOS home-screen apps never truly close their clients, so
// waiting workers waited FOREVER — stale builds kept serving and superseded caches piled up):
// if an updated worker is waiting at startup, activate it immediately and reload once. The swap
// is ONE reload on controllerchange — and since the worker calls skipWaiting() at install, an
// update can also land MID-SESSION (declared trade-off, blind review M2 MINOR 4: this comment
// used to say "never mid-session", which was false — every action is already persisted as an
// event, so the reload never loses data).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  void navigator.serviceWorker
    .register(`${import.meta.env.BASE_URL}sw.js`, { updateViaCache: "none" }) // sw.js mai da HTTP cache
    .then((reg) => {
      // Update checks run on navigation or explicit update() [A OpenPWA/web.dev]: a home-screen
      // app resumed from background performs NO navigation -> without this, updates stall while
      // the app is used daily (research 2026-09-24-ios-pwa-sw-lifecycle, H3 killed).
      const checkUpdate = (): void => {
        void reg.update().catch(() => {
          /* offline: l'update check è best-effort */
        });
      };
      window.addEventListener("pageshow", checkUpdate);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") checkUpdate();
      });
      const activateUpdate = (worker: ServiceWorker | null): void => {
        // first install must NOT reload the page: only swap of an already-controlled page
        if (worker && hadController) worker.postMessage({ type: "SKIP_WAITING" });
      };
      activateUpdate(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed") activateUpdate(reg.waiting ?? nw);
        });
      });
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (!hadController || refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    })
    .catch((err: unknown) => {
      console.warn("service worker non registrato:", err);
    });
}

startPerf(); // misura baseline web-vitals in locale (build plan M0): prima del render, LCP si osserva dall'inizio
render(() => <App />, root);
